import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    BillingCompany,
} from '../../BillingCompanyForm.types'

const getAddressDetailsFields = ({
    setAutocomplete,
    currentPlaceId,
    value,
    isGoogleMapsServiceLoaded,
}): DTOCardFormField<keyof BillingCompany> => {
    return {
        id: 'addressDetails',
        title: 'Address Details',
        className: 'addressDetails',
        'data-testid': 'card-addressDetails',
        fields: [{
            id: 'addressDetails-column1',
            fields: [
                {
                    name: 'billingLocationName',
                    componentName: 'InputSingleline',
                    required: true,
                    labelKey: 'BillingCompanyDto.billingLocationName',
                },
                {
                    name: 'street',
                    componentName: 'InputSingleline',
                    required: true,
                    labelKey: 'BillingCompanyDto.street',
                },
                {
                    name: 'houseNumber',
                    componentName: 'InputSingleline',
                    required: true,
                    labelKey: 'Order.houseNumber',
                },
                {
                    name: 'addressLine2',
                    componentName: 'InputSingleline',
                    labelKey: 'BillingCompanyDto.addressLine2',
                },
                {
                    name: 'company',
                    componentName: 'CompanyObjectSelector',
                    required: true,
                    labelKey: 'BillingCompanyDto.company',
                },
                isGoogleMapsServiceLoaded
                    ? {
                        name: 'additional',
                        componentName: 'GoogleAddress',
                        setAutocomplete,
                        currentPlaceId,
                        formData: value,
                        isGoogleMapsServiceLoaded,
                        labelKey: 'BillingCompanyDto.additional',
                    } : {
                        name: 'additional',
                        required: true,
                        componentName: 'InputSingleline',
                        labelKey: 'BillingCompanyDto.additional',
                    },
                {
                    name: 'zip',
                    componentName: 'InputSingleline',
                    required: true,
                    labelKey: 'BillingCompanyDto.zip',
                },
                {
                    componentName: 'CitySuggestions',
                    name: 'city',
                    required: true,
                    labelKey: 'BillingCompanyDto.city',
                },
                {
                    name: 'country',
                    labelKey: 'BillingCompanyDto.country',
                    componentName: 'CountryDataSelector',
                    required: true,
                },
            ],
        }],
    }
}

export default getAddressDetailsFields
